
import { useState, useEffect } from 'react';

// Hook customizado para "atrasar" a atualização de um valor (debounce)
function useDebounce(value, delay) {
  // Estado para armazenar o valor "atrasado"
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Cria um temporizador que só vai atualizar o valor "atrasado" após o delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Função de limpeza: cancela o temporizador se o valor mudar antes do delay terminar.
    // Isso garante que a atualização só aconteça quando o usuário parar de digitar.
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); // Roda o efeito novamente apenas se o valor ou o delay mudarem

  return debouncedValue;
}

export default useDebounce;
